import { Copyable } from 'ember-copy';
import moment from 'moment';
import EmberObject, { computed } from '@ember/object';

// FloatingDate is used to represent values that are not related to a
// specific moment in time, but rather require local information to determine
// a range of acceptable incremental time values.
//
// Note that a FloatingDate should never be attached to a particular time zone.
//
// Common examples of floating dates include: birthdates, publication dates,
// expiration dates, and holidays.
//
// Reference:
// https://www.w3.org/TR/timezone/#floating
const FloatingDate = EmberObject.extend(Copyable, {
  year: null,
  month: null,
  day: null,

  jsDate: computed('year', 'month', 'day', function() {
    const year = this.get('year');
    const month = this.get('month');
    const day = this.get('day');
    const jsDate = moment(`${year}-${month}-${day}`, 'YYYY-M-D', true).toDate();

    if (isNaN(jsDate)) {
      return null;
    } else {
      return jsDate;
    }
  }),

  copy() {
    return this.constructor.create({
      year: this.get('year'),
      month: this.get('month'),
      day: this.get('day'),
    });
  },
});

export default FloatingDate;
